import { render, staticRenderFns } from "./InternationalShipping.vue?vue&type=template&id=e6042166&scoped=true&"
import script from "./InternationalShipping.vue?vue&type=script&lang=js&"
export * from "./InternationalShipping.vue?vue&type=script&lang=js&"
import style0 from "./InternationalShipping.vue?vue&type=style&index=0&id=e6042166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6042166",
  null
  
)

export default component.exports